import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17cd2b8b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "app-welcome" };
const _hoisted_2 = { class: "app-welcome__content" };
const _hoisted_3 = { class: "app-welcome__title" };
const _hoisted_4 = { class: "app-welcome__subtitle" };
const _hoisted_5 = ["href"];
const _hoisted_6 = { class: "app-welcome__logo" };
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
import { computed, onMounted } from 'vue';
import { useMixpanelConfig } from '@/utilities/mixpanel';
const APP_STORE_URL = 'https://apps.apple.com/br/app/oto-crm/id1522083651';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=br.com.pmweb360&hl=pt_BR';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppWelcome',
    setup(__props) {
        const downloadUrl = computed(() => {
            const userAgent = navigator.userAgent;
            if (/iPad|iPhone|iPod/.test(userAgent)) {
                return APP_STORE_URL;
            }
            useMixpanelConfig('click_migration360_seller_download');
            return PLAY_STORE_URL;
        });
        onMounted(() => {
            useMixpanelConfig('view_migration360_seller_download');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('login360.welcome.title')), 1),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('login360.welcome.subtitle')), 1),
                    _createElementVNode("a", {
                        href: downloadUrl.value,
                        class: "app-welcome__button"
                    }, _toDisplayString(_ctx.$t('login360.welcome.downloadButton')), 9, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                        src: require('@/assets/svgs/login/welcome-image.svg'),
                        alt: "Oto Logo"
                    }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("img", {
                    src: require('@/assets/svgs/login/waves.svg'),
                    class: "app-welcome__bg"
                }, null, 8, _hoisted_8)
            ]));
        };
    }
});
